// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3vDrC","location":"Header_location__1kXAH"};